import { render, staticRenderFns } from "./DepoDeals.vue?vue&type=template&id=74ae2fc2"
import script from "./DepoDeals.vue?vue&type=script&lang=js"
export * from "./DepoDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports